module.exports = __webpack_public_path__ + "static/media/sign_in.3a109c12.svg";